import { ChatProps } from '@speeki/chat-web-components';

import { SITE_HEADER_HEIGHT } from '@components/organisms/Header/Header.styled';

import { REPORT_CHAT_SIZE_STORAGE_KEY } from '@domains/Chat/ChatElement/reportChatStorage';

/**
 * The incident report chat: 3,600-character messages with a counter, and a
 * panel the reporter can enlarge, with the input growing along with it.
 *
 * The chosen size lives in `sessionStorage`, never `localStorage`: a lasting
 * trace on a shared computer that someone opened the whistleblowing chat is
 * exactly what an anonymous reporter must not leave behind. The panel is kept
 * clear of the sticky site header, or a full-height drag would put its handle
 * and close button underneath it.
 *
 * The Disclosures chat uses `ChatElement` without these, and so is unchanged.
 */
export const REPORT_CHAT_SETTINGS = {
    inputGrowsWithPanel: true,
    maxInputLength: 3600,
    maxInputRows: 6,
    resizable: true,
    resizeStorage: 'session',
    resizeStorageKey: REPORT_CHAT_SIZE_STORAGE_KEY,
    resizeTopInset: SITE_HEADER_HEIGHT,
    showInputCounter: true,
} satisfies Partial<ChatProps>;
